// src/components/EnvDebug.js
import React, { useState } from 'react';

const EnvDebug = () => {
  const [showDetails, setShowDetails] = useState(false);

  const envVars = {
    // Original API
    'REACT_APP_STRAPI_API_URL': process.env.REACT_APP_STRAPI_API_URL || '(not set)',
    'REACT_APP_STRAPI_API_TOKEN': process.env.REACT_APP_STRAPI_API_TOKEN ? '(exists but hidden)' : '(not set)',
    // Request Demo API
    'REACT_APP_REQUEST_DEMO_API_URL': process.env.REACT_APP_REQUEST_DEMO_API_URL || '(not set)',
    'REACT_APP_REQUEST_DEMO_API_TOKEN': process.env.REACT_APP_REQUEST_DEMO_API_TOKEN ? '(exists but hidden)' : '(not set)',
    // Other
    'NODE_ENV': process.env.NODE_ENV || '(not set)'
  };

  return (
    <div style={{
      margin: '20px 0',
      padding: '10px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px'
    }}>
      <h5 style={{ marginBottom: '10px' }}>Environment Variables</h5>

      <button
        onClick={() => setShowDetails(!showDetails)}
        style={{
          padding: '5px 10px',
          backgroundColor: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          marginBottom: '10px',
          cursor: 'pointer'
        }}
      >
        {showDetails ? 'Hide Details' : 'Show Details'}
      </button>

      {showDetails && (
        <div>
          <h6 style={{ marginTop: '15px', marginBottom: '5px' }}>Original API</h6>
          <p style={{ margin: '5px 0', color: envVars['REACT_APP_STRAPI_API_URL'] === '(not set)' ? 'red' : 'inherit' }}>
            <strong>API URL:</strong> {envVars['REACT_APP_STRAPI_API_URL']}
          </p>
          <p style={{ margin: '5px 0', color: envVars['REACT_APP_STRAPI_API_TOKEN'] === '(not set)' ? 'red' : 'inherit' }}>
            <strong>API Token:</strong> {envVars['REACT_APP_STRAPI_API_TOKEN']}
          </p>

          <h6 style={{ marginTop: '15px', marginBottom: '5px' }}>Request Demo API</h6>
          <p style={{ margin: '5px 0', color: envVars['REACT_APP_REQUEST_DEMO_API_URL'] === '(not set)' ? 'red' : 'inherit' }}>
            <strong>API URL:</strong> {envVars['REACT_APP_REQUEST_DEMO_API_URL']}
          </p>
          <p style={{ margin: '5px 0', color: envVars['REACT_APP_REQUEST_DEMO_API_TOKEN'] === '(not set)' ? 'red' : 'inherit' }}>
            <strong>API Token:</strong> {envVars['REACT_APP_REQUEST_DEMO_API_TOKEN']}
          </p>

          <h6 style={{ marginTop: '15px', marginBottom: '5px' }}>Other</h6>
          <p style={{ margin: '5px 0' }}>
            <strong>NODE_ENV:</strong> {envVars['NODE_ENV']}
          </p>
          <p style={{ marginTop: '10px', fontSize: '0.9em' }}>
            <strong>Note:</strong> Environment variables in React must start with REACT_APP_
          </p>
        </div>
      )}
    </div>
  );
};

export default EnvDebug;